

























import { Prop, Component, Vue } from "vue-property-decorator";
import { Task } from "@/api/task-api";
import VTask from "@/components/task/VTask.vue";
import TaskFormData from "@/api/models/TaskFormData";
import SubTaskList from "../components/SubTaskList.vue";
import SubTaskListItem from "../components/SubTaskListItem.vue";

@Component({
  components: {
    SubTaskList,
    SubTaskListItem,
    VTask
  },
  model: {
    prop: "open",
    event: "change"
  }
})
export default class TaskModal extends Vue {
  @Prop({ type: Boolean }) open!: boolean;
  @Prop({ type: Object }) task?: Task | null;

  async updateTask() {
    if (!this.task) {
      throw new Error("task is not set.");
    }
    const d = TaskFormData(this.task, {
      hasClosedDays: true,
      hasSubTasks: true
    });
    await this.$store.dispatch("saveTask", d);
  }
}
